import styled from "styled-components";
import { colors, types } from "../../../libs";
import { Button, Container, Modal } from "react-bootstrap";

export const ModalHeader = styled(Modal.Header)`
  background:  ${colors.background.lightBlack};
  color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
  color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
  position: sticky;
  top: 0;
  z-index: 10;
`;


export const ModalBodyWrapper = styled.div`
 overflow-y: auto;
`;


export const FullscreenImage = styled.img`
  object-fit: contain;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CustomButton = styled(Button)`
 background: ${colors.background.lightGrey};
  color: ${colors.text.white};
  padding: 8px 16px; 
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap; 
  &:hover {
    background: ${colors.background.greyWhite};
  }
`;

export const SaveButton = styled(Button)`
`;
